import React, { useEffect, useState } from "react";
import { withFirebase } from "../../firebase";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import DeliveryZonesControl from "./deliveryZonesControl";

const DeliveryZonesControlContainer = (props) => {
	const cities = useSelector((state) => state.shops.shops);
	const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
	const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));

	const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
	const isNewAdmin = adminPermission?.newAdmin;

	const zones = isNewAdmin
		? cities[currentCity]?.brands?.[currentBrand]?.checkoutScreen
				?.deliverySettings?.deliveryZone
		: cities[currentCity]?.checkoutScreen?.deliverySettings?.deliveryZone;

	const [zonesState, setZonesState] = useState(zones);

	const onSubmit = () => {
		const isValid = !!zonesState?.find((item) => item?.isActive === true);
		const ref = isNewAdmin
			? `/web/settings/city/${currentCity}/brands/${currentBrand}/checkoutScreen/deliverySettings/deliveryZone`
			: `/web/settings/city/${currentCity}/checkoutScreen/deliverySettings/deliveryZone`;

		if (isValid) {
			props.firebase.bd
				.ref(ref)
				.update(zonesState)
				.then(() => {
					alert("Готово");
				})
				.catch(() => {
					alert("Щось пішло не так, спробуйте ще раз");
				});
		} else {
			alert("Мінімум одна зона повинна бути активна");
		}
	};

	useEffect(() => {
		zones && setZonesState(zones);
	}, [JSON.stringify(zones)]);

	return (
		<div>
			{zonesState && (
				<DeliveryZonesControl
					zones={zonesState}
					setZones={setZonesState}
					saveData={onSubmit}
				/>
			)}
		</div>
	);
};

export default withRouter(withFirebase(DeliveryZonesControlContainer));
